const CurrentRedemptionAction = require('@/lib/Memberships/CurrentRedemptionAction');
const EventNames = require('@/lib/Events/EventNames');
const { container } = require('@/container');

class MembershipRedemptionService {
    /**
     * @param {CurrentDevice} currentDevice
     * @param redemptionResource
     * @param {RedemptionService} redemptionService
     * @param {ToastFactory} toastFactory
     */
    constructor(
        currentDevice,
        redemptionResource,
        redemptionService,
        toastFactory
    ) {
        this.currentDevice = currentDevice;
        this.redemptionResource = redemptionResource;
        this.redemptionService = redemptionService;
        this.toastFactory = toastFactory;
    }

    /**
     * @param {Membership} membership
     * @param {MembershipSubscription} membershipSubscription
     * @param {MembershipPlan} membershipPlan
     * @param {function} [callback]
     */
    logVisit(
        membership,
        membershipSubscription,
        membershipPlan,
        callback
    ) {
        this.updateMembershipVisits(membership, membershipSubscription, membershipPlan, +1, callback);
    }

    /**
     * @param {Membership} membership
     * @param {MembershipSubscription} membershipSubscription
     * @param {MembershipPlan} membershipPlan
     * @param {function} [callback]
     */
    unlogVisit(
        membership,
        membershipSubscription,
        membershipPlan,
        callback,
    ) {
        this.updateMembershipVisits(membership, membershipSubscription, membershipPlan, -1, callback);
    }

    /**
     * @private
     *
     * @param {Membership} membership
     * @param {MembershipSubscription} membershipSubscription
     * @param {MembershipPlan} membershipPlan
     * @param {number} qty
     * @param {function} [callback]
     */
    updateMembershipVisits(
        membership,
        membershipSubscription,
        membershipPlan,
        qty,
        callback,
    ) {
        const isRedemption = qty > 0;
        const isUnredemption = qty < 0;

        // In order to avoid double click type errors we set the member.currentRedemptionAction as soon as a button is
        // clicked. If this error is triggered this code is being called via a new code path.
        if (membership.currentRedemptionAction === CurrentRedemptionAction.NONE) {
            console.error('updateMembershipVists has been called but membership.currentRedemptionAction === NONE');
            return;
        }

        const onFinish = () => {
            membership.currentRedemptionAction = CurrentRedemptionAction.NONE;
            container.eventBus.broadcast(EventNames.MEMBERSHIP_REDEMPTION_ACTIVITY);
        };

        // FIXME: This does not have offline redemption support.
        this.redemptionResource.redeem(
            {
                ...this.redemptionService.getDefaultRedemptionData(),
                qty,
                ref: membership.getRef(),
                type: 'membership',
            },
            (data) => {
                if (data.success) {
                    membershipSubscription.setVisits(data.newRedemptionCount);
                    membership.setMemberVisits(data.memberRedemptionData);
                    if (callback) {
                        callback(data);
                    }
                } else {
                    if (isRedemption) {
                        this.toastFactory.errorTop(
                            'MEMBERSHIPS.ERROR_TITLE__MEMBERSHIP_REDEMPTION',
                            data.message || '',
                        );
                    } else if (isUnredemption) {
                        this.toastFactory.errorTop(
                            'MEMBERSHIPS.ERROR_TITLE__MEMBERSHIP_UNREDEMPTION',
                            data.message || '',
                        );
                    }
                }

                onFinish();
            },
            (response) => {
                if (isRedemption) {
                    this.toastFactory.errorTop(
                        'MEMBERSHIPS.ERROR_TITLE__MEMBERSHIP_REDEMPTION',
                        response.data.message || '',
                    );
                } else if (isUnredemption) {
                    this.toastFactory.errorTop(
                        'MEMBERSHIPS.ERROR_TITLE__MEMBERSHIP_UNREDEMPTION',
                        response.data.message || '',
                    );
                }
                onFinish();
            },
        );
    }

    /**
     * @param {Member} member
     * @param {MembershipSubscription} membershipSubscription
     * @param {MembershipPlan} membershipPlan
     * @param {number} qty
     * @param {function} callback
     */
    updateMemberVisits(member, membershipSubscription, membershipPlan, qty, callback) {
        if (!membershipPlan.membershipsCanBeRedeemedToday) {
            return;
        }

        // In order to avoid double click type errors we set the member.currentRedemptionAction as soon as a button is
        // clicked. If this error is triggered this code is being called via a new code path.
        if (member.currentRedemptionAction === CurrentRedemptionAction.NONE) {
            console.error('updateMemberVists has been called but member.currentRedemptionAction === NONE');
            return;
        }

        const isRedemption = qty > 0;
        const isUnredemption = qty < 0;

        const onFinish = () => {
            member.currentRedemptionAction = CurrentRedemptionAction.NONE;
            container.eventBus.broadcast(EventNames.MEMBERSHIP_REDEMPTION_ACTIVITY);
        };

        // FIXME: This does not have offline redemption support.
        this.redemptionResource.redeem(
            {
                ...this.redemptionService.getDefaultRedemptionData(),
                qty,
                ref: member.getID(),
                type: 'member',
            },
            (data) => {
                if (data.success) {
                    membershipSubscription.setVisits(data.newRedemptionCount);
                    member.setVisits(data.hasOwnProperty('newMemberRedemptionData') ? data.newMemberRedemptionData : {});
                    if (callback) {
                        callback(data);
                    }
                } else {
                    if (isRedemption) {
                        this.toastFactory.errorTop(
                            'MEMBERSHIPS.ERROR_TITLE__MEMBER_REDEMPTION',
                            data.message || '',
                        );
                    } else if (isUnredemption) {
                        this.toastFactory.errorTop(
                            'MEMBERSHIPS.ERROR_TITLE__MEMBER_UNREDEMPTION',
                            data.message || '',
                        );
                    }
                }

                onFinish();
            },
            (response) => {
                if (isRedemption) {
                    this.toastFactory.errorTop(
                        'MEMBERSHIPS.ERROR_TITLE__MEMBER_REDEMPTION',
                        response.data.message || '',
                    );
                } else if (isUnredemption) {
                    this.toastFactory.errorTop(
                        'MEMBERSHIPS.ERROR_TITLE__MEMBER_UNREDEMPTION',
                        response.data.message || '',
                    );
                }

                onFinish();
            }
        );
    }
}

module.exports = MembershipRedemptionService;
